const CONSTANTS = {
    // devices
    ON_DEVICE_LIST_IS_LOADING: 'devices/ON_DEVICE_LIST_IS_LOADING',
    ON_DEVICE_LIST: 'devices/ON_DEVICE_LIST'
};

export { CONSTANTS };
